<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>Foremost, I would like to thank warmly everyone around the world who took part in my research by giving their time and openly sharing their experiences in Casa de Dom Inácio. I would like to present my heartfelt thanks also to the organisations and the group of persons for helping me to find additional interviewees for my research in Finland, where I live, and for organising the facilities for the interviews. I appreciate very much the small grant I got from Finnish Association of Occultism as a support for the study. To my mother, thank you for the love you have shown by praying for me during the research and the writing process and throughout my whole life. I would like to express my gratitude also to my husband and to my four grown children for their understanding of my trips to Brazil and my writing work.</p>
<p>Finally, I want to offer my deep gratitude to the spiritual helpers for guiding me through this process. A special thanks to the Highest power of the universe and Archangel Michael, Archangel Rafael, my guardian angels, my spirit guides and the entities in Casa.</p>
<p>Writing this book would not have been possible without the lifework of the Brazilian João Teixeira de Faria and his devotion to helping people and serving God in the spiritual healing centre Casa de Dom Inácio that he has established. It also wouldn’t have been possible without his willingness to cooperate with the healer spirits i.e. the entities.</p>
<hr/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?62bd3dc9